module.exports = __webpack_public_path__ + "img/transfer.5ce54000.png";